// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"0ff38bf9","725":"acd00810","787":"654e296d"}[chunkId] + ".chunk.js";
};